import 'globals';

(function (window) {
    /**
     * Get the current viewport
     */
    class Viewport {
        static breakpoints = ['xs', 'sm', 'md', 'lg', 'xl'];
        #viewportSizes = [];
        currentViewport = {breakpoint: 'xs', size: 0};
        viewport = {};

        /**
         * Constructor
         */
        constructor() {
            this.#setViewportSizes();
            this.#setCurrentViewport(true);
            this.#setViewports(true);
        }

        /**
         * Getter for the current viewport
         * @return {JSON}
         */
        get currentViewport() {
            return this.currentViewport;
        }

        /**
         * Getter for the viewport
         * @return {JSON}
         */
        get viewport() {
            return this.viewport;
        }

        /**
         * Set all viewport sizes that are linked to the following and previous size
         */
        #setViewportSizes() {
            Viewport.breakpoints.forEach((breakpoint, index) => {
                const breakpointSize = getComputedStyle(document.body).getPropertyValue('--breakpoint-' + breakpoint);

                if (breakpointSize) {
                    this.#viewportSizes[breakpoint] = {
                        size: parseInt(breakpointSize.replace('px', '')),
                        after: index >= Viewport.breakpoints.length ? null : Viewport.breakpoints[index + 1],
                        before: index === 0 ? null : Viewport.breakpoints[index - 1]
                    };
                }
            });
        }

        /**
         * Set all values for the viewports
         *
         * @param {boolean} initEventListener
         */
        #setViewports(initEventListener = false) {
            if (!this.#viewportSizes) {
                this.#setViewportSizes();
            }
            Viewport.breakpoints.forEach((breakpoint, index) => {
                this.viewport[breakpoint] = {
                    up: true
                };

                // Skip the first size because it is the smallest one
                if (index > 0) {
                    this.viewport[breakpoint].up = true;

                    if ('matchMedia' in window) {
                        const breakpointSize = this.#viewportSizes[breakpoint].size,
                            mqUp = matchMedia(`(min-width: ${breakpointSize}px`);

                        this.viewport[breakpoint].up = mqUp.matches;

                        if (initEventListener) {
                            mqUp.addEventListener('change', (mq) => {
                                    this.viewport[breakpoint].up = mqUp.matches;
                                },
                                {passive: true});
                        }
                    }

                    // skip the last breakpoint
                    if (index + 1 < Viewport.breakpoints.length) {
                        this.viewport[breakpoint].down = true;

                        if ('matchMedia' in window) {
                            const nextBreakpoint = Viewport.breakpoints[index + 1],
                                maxWidthSize = this.#viewportSizes[nextBreakpoint].size - 1,
                                mqDown = matchMedia(`(max-width: ${maxWidthSize}px)`);

                            this.viewport[breakpoint].down = mqDown.matches;

                            if (initEventListener) {
                                mqDown.addEventListener('change', (mq) => {
                                        this.viewport[breakpoint].down = mq.matches;
                                    },
                                    {passive: true});
                            }
                        }
                    }
                }
            });
        }

        /**
         * Set the current viewport
         * @param {boolean} initEventListener
         */
        #setCurrentViewport(initEventListener = false) {
            if (!this.#viewportSizes) {
                this.#setViewportSizes();
            }
            let currentViewport;

            Viewport.breakpoints.forEach((breakpoint) => {
                const checkMedia = matchMedia('(min-width: ' + this.#viewportSizes[breakpoint].size + 'px)');

                if (checkMedia.matches) {
                    currentViewport = breakpoint;
                }

                if (initEventListener) {
                    checkMedia.addEventListener('change', () => {
                        this.#setCurrentViewport();
                    }, {passive: true});
                }
            });

            this.currentViewport = {
                breakpoint: currentViewport,
                size: this.#viewportSizes[currentViewport].size
            };
        }
    }

    window.Viewport = () => {
        return new Viewport();
    }

    // For legacy usage
    window.viewport = window.Viewport().viewport;
})(window);
